// extracted by mini-css-extract-plugin
export var box = "_5k-0";
export var check = "_5k-1";
export var checkboxButton = "_5k-6";
export var checkboxGroup = "_5k-5";
export var disabled = "_5k-7";
export var ghost = "_5k-9";
export var input = "_5k-2";
export var label = "_5k-4";
export var normal = "_5k-8";
export var uncheck = "_5k-3";